import { useState } from 'react';

// lib
import { motion } from "framer-motion";

// utils
import * as constants from '../../Utils/constants';

const FormHero = () => {

    const [imageLoading, setImageLoading] = useState(true);
    const [pulsing, setPulsing] = useState(true);

    const imageLoaded = () => {
        setImageLoading(false);
        setTimeout(() => setPulsing(false), 600);
    };
    return (
        <section className="top-nav">
            <div className="top-nav__content">
                <div className="top-nav__content__img__container">
                    <motion.img
                        className={`${pulsing ? "pulse" : ""}`}
                        onLoad={imageLoaded}
                        height={`${150}px`}
                        width={`${280}px`}
                        src={`../../../images/${0}.svg`}
                        alt=''
                    />
                </div>
                <div>
                    <h1 className="top-nav__content__headline">{constants.hero.headline}</h1>
                    <p className="top-nav__content__preamble">{constants.hero.text}</p>
                </div>
            </div>
        </section>
    )
}

export default FormHero;

